export const PADDING_Y = 96;
export const SECTION_GAP = 24;
export const BLOCK_GAP = 20;
export const CONTENT_WIDTH = 650;
export const BUFFER = 40;

// Altura mínima de conteúdo que a primeira página precisa sobrar depois da
// tabela de identificação. A tabela cresce com o texto da Finalidade; abaixo
// desse piso não cabe nem um parágrafo, e o splitter acabaria empurrando a
// seção inteira para dentro da página 1 (process-text força a colocação em
// página "fresca"). Nesse caso o conteúdo começa na página 2.
export const MIN_PAGE1_CONTENT_HEIGHT = 160;

export const REPORT_HEADER_MEASUREMENT_ID = 'report-header';
export const REPORT_PATIENT_INFO_MEASUREMENT_ID = 'patient-info';
export const REPORT_FOOTER_MEASUREMENT_ID = 'report-footer';
export const REPORT_SIGNATURE_MEASUREMENT_ID = 'report-signature';

export const FIXED_REPORT_MEASUREMENT_IDS = [
    REPORT_HEADER_MEASUREMENT_ID,
    REPORT_PATIENT_INFO_MEASUREMENT_ID,
    REPORT_FOOTER_MEASUREMENT_ID,
    REPORT_SIGNATURE_MEASUREMENT_ID,
];

// Default heights for missing measurements
export const DEFAULT_HEADER_HEIGHT = 150;
export const DEFAULT_FOOTER_HEIGHT = 100;
export const DEFAULT_PATIENT_INFO_HEIGHT = 180;
export const DEFAULT_SIGNATURE_HEIGHT = 96;
export const DEFAULT_TITLE_HEIGHT = 50;
export const DEFAULT_SECTION_HEIGHT = 100;
export const DEFAULT_BLOCK_HEIGHT = 150;
export const EMPTY_PLACEHOLDER_HEIGHT = 100;
